<div class="container">
                
       <div class="center">
        <h1><strong>Your Order has been Confirmed!</strong></h1>
        <h4>Confirmation Number: #{{cart.getConfirmationNum()}}</h4>
        <h4><em>Please look out for an email for your confirmation number from your friends at Exchange4Students!</em></h4>
        <br>
        <br>
        <div class="row">

            <div class="column">
                <a routerLink="/home" routerLinkActive="active"> 
                <img src="https://firebasestorage.googleapis.com/v0/b/exchange4students.appspot.com/o/images%2FPrice_Tag.PNG?alt=media&token=26fb9612-6531-4cc1-b9fd-0e035cfac3d9" alt="Price Tag" width="200" height="200"></a>
                <h4><em>Click to go to Homepage</em></h4>
            </div>

            <div class="column">
                <a routerLink="/cart" routerLinkActive="active"> 
                <img src="https://firebasestorage.googleapis.com/v0/b/exchange4students.appspot.com/o/images%2FShopping_Cart.JPG?alt=media&token=ed843e41-2be7-4539-899f-bc3b8fa6bdd9" alt="Package" width="200" height="200"></a>
                <h4><em>Click to go Back to Cart</em></h4>
            </div>

                    
        </div>
        <br>
    </div>
                    
</div>
